type ErrorWithCode = {
  response?: {
    data?: {
      detail?: {
        code?: string;
      };
    };
  };
};

export function isDraftPendingReviewError(error: unknown): boolean {
  if (!error || typeof error !== "object") {
    return false;
  }
  const detailCode = (error as ErrorWithCode).response?.data?.detail?.code;
  return detailCode === "DRAFT_PENDING_REVIEW";
}
